import { BookOen } from "./icons/BookOpen";
import { Ticket } from "./icons/Ticket";
import { HeaderAccountProps } from "./type";
import { UserCircle } from './icons/UserCircle';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from "react";


export function HeaderAccount({
  handleClick,
  activeMenuItem,
  profile
}: Readonly<HeaderAccountProps>) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#reservations") {
      handleClick(2);
      navigate("/account-billing");
    }
  }, [location.hash, handleClick]);


  return (
    <header className="container border-[0.07rem] border-neutral-100 dark:border-neutral-700 h-20 shadow-lg rounded-3xl md:rounded-full mt-5 md:mt-12 flex dark:bg-neutral-900 justify-between mx-auto items-center">
      <nav className="flex items-center mx-auto justify-evenly md:justify-center w-full gap-1 md:gap-8">
        <li className="list-none flex border-2 border-transparent h-20 relative items-center">
          <button
            className="dark:text-white p-1 md:p-4 cursor-pointer flex flex-col items-center"
            onClick={() => handleClick(0)}
          >
            <UserCircle className="w-8 h-8 mb-1 md:mb-auto" color={activeMenuItem === 0 ? '#4F46E5' : 'currentColor'} />
            <p className={`${activeMenuItem === 0 ? 'text-[#4F46E5]' : 'text-neutral-700 dark:text-neutral-400'} text-xs md:text-base`}>
              {window.innerWidth < 768 ? 'Dados' : 'Meus Dados'}
            </p>
            <div 
              className={`
                absolute -bottom-1 left-0 w-full h-[0.1rem] md:h-1
                rounded bg-[#4F46E5] ${activeMenuItem === 0 ? '' : 'hidden'}
              `}
            ></div>
          </button>
        </li>
        <li className="list-none flex border-2 border-transparent h-20 relative items-center">
          <button
            className={`p-1 md:p-4 cursor-pointer flex flex-col items-center ${profile.subscription ? 'dark:text-white' : 'disabled:text-gray-300 dark:text-[#4b4b4b]'}`}
            onClick={() => handleClick(1)}
            disabled={!profile.subscription}
          >
            <BookOen className="w-8 h-8 mb-1 md:mb-auto" color={activeMenuItem === 1 ? '#4F46E5' : 'currentColor'} />
            <p className={`${profile.subscription ? (activeMenuItem === 1 ? 'text-[#4F46E5]' : 'text-neutral-700 dark:text-neutral-400') : 'text-gray-300 dark:text-[#4b4b4b]'} text-xs md:text-base`}>
              {window.innerWidth < 768 ? 'Assinatura' : 'Minha Assinatura'}
            </p>
            <div 
              className={`
                absolute -bottom-1 left-0 w-full h-[0.1rem] md:h-1
                rounded bg-[#4F46E5] 
                ${activeMenuItem === 1 ? 'transition-all ease-in-out duration-500' : 'hidden'}
              `}
            ></div>
          </button>
        </li>
        <li className="list-none flex border-2 border-transparent h-20 relative items-center" id="reservations">
          <button
            className="dark:text-white p-1 md:p-4 cursor-pointer flex flex-col items-center"
            onClick={() => {
              handleClick(2);
            }}
          >
            <Ticket className="w-8 h-8 mb-1 md:mb-auto" color={activeMenuItem === 2 ? '#4F46E5' : 'currentColor'} />
            <p className={`${activeMenuItem === 2 ? 'text-[#4F46E5]' : 'text-neutral-700 dark:text-neutral-400'} text-xs md:text-base`}>
              {window.innerWidth < 768 ? 'Reservas' : 'Minhas Reservas'}
            </p>
            <div 
              className={`
                absolute -bottom-1 left-0 w-full h-[0.1rem] md:h-1
                rounded bg-[#4F46E5] 
                ${activeMenuItem === 2 ? 'transition-all ease-in-out duration-500' : 'hidden'}
              `}
            ></div>
          </button>
        </li>
      </nav>
    </header>
  )
}
